<template>
  <div class="import-card">
    <div class="import-info">
      <div class="main-info-top">
        <div class="title-badges">
          <div class="import-text row">
            <div class="title">
              <router-link
                style="text-decoration: none"
                :to="{
                  name: 'FileRecordsOverview',
                  params: { fileId: id },
                }"
              >
                <span v-html="fileName"></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="details">
        <div class="text-details row">
          <div class="detail-item">
            <span class="detail-tag">Server naam</span>
            <span class="detail-value">{{ serverFileName }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-tag">Datum importeren</span>
            <span class="detail-value">{{ updatedDate }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-tag">Status</span>
            <span class="detail-value">{{ status }}</span>
          </div>
        </div>
        <div class="action-btns row items-center">
          <!--<q-btn flat                           
                            class="import-btn">
                            Klaar voor importeren
                        </q-btn>-->

          <i
            class="las la-2x la-trash la-fw action-icon"
            color="red"
            @click="confirmDeleteFile = true"
          >
            <q-tooltip> Map verwijderen </q-tooltip>
          </i>
        </div>
      </div>
      <div class="details">
        <div
          class="text-details row"
          v-if="exception != null && exception != ''"
        >
          <div class="detail-item">
            <span class="detail-tag">Fout</span>
            <span class="detail-value">{{ exception }}</span>
          </div>
        </div>
      </div>
    </div>

    <q-dialog v-model="confirmDeleteFile" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <i class="las la-2x la-trash la-fw"></i>
          <span class="q-ml-sm">
            Weet je zeker dat je dit bestand met de data daarin wilt
            verwijderen?
          </span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            style="background: #0a108f; color: white"
            label="Verwijderen"
            no-caps
            v-close-popup
            @click="removeFile()"
          />
          <q-btn
            style="
              color: #0a108f;
              border: 1px solid gray;
              border-radius: 5px;
            "
            no-caps
            label="Annuleren"
            flat
            v-close-popup
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
  <FileRecordsErrorModal />
</template>
<script>
import ImportsService from '../services/imports.service';
import { ref } from 'vue';
import FileRecordsErrorModal from './FileRecordsErrorModal.vue';

export default {
  name: 'FilesOverviewCard',
  components: {
    FileRecordsErrorModal,
  },
  props: {
    id: Number,
    fileName: String,
    serverFileName: String,
    status: String,
    updatedDate: Date,
    exception: String,
  },
  setup(props) {

    const confirmDeleteFile = ref(false);
    const fileId = ref(props.id);

    const removeFile = async () => {
      await ImportsService.removeImportedFile(fileId.value);
      ImportsService.loadImports();
    };

    return {
      confirmDeleteFile,
      removeFile,
      fileId,
    };
  },

  // data() {
  //     return {
  //         confirmDeleteFile: false,
  //     };
  // },
  // methods: {
  //     async removeFile() {
  //         await ImportsService.removeImportedFile(this.id);
  //         ImportsService.loadImports();
  //     }
  // },

  // This is pure garbage, this vue3 way of doing things.. "this" does not persist ...
  //setup() {
  //    const confirmDeleteFile = ref(false);
  //    const removeFile = async () => {
  //        console.log(this)
  //        console.log(this.id)
  //        // await ImportsService.removeImportedFile(this.id);
  //        // ImportsService.loadImports();
  //        //  await UserService.removeFile(folderId);
  //        //  UserService.getFoldersWithItems();
  //    };

  //    return {
  //        confirmDeleteFile,
  //        removeFile,
  //    }
  //},
};
</script>
